export default "__VITE_ASSET__GP2naUeg__"